import { RegisterPaqueteForm } from "@/components/forms/paquetes/PaqueteForms";
import { Button } from "@/shared/components/ui/button";
import DataTable from "@/components/ui/dataTable";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/Skeleton";
import { usePaquetes } from "@/hooks/paquetes/usePaquetes";
import type { Paquete } from "@/interfaces/paquetes.interface";
import { getPaqueteColumns } from "@/lib/columns/paquetes.columns";
import { useMemo, useState } from "react";

export interface PaquetesResponse {
  data: Paquete[];
  total: number;
}

export default function Paquetes() {
  const [open, setOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const [search, setSearch] = useState("");

  const { data, isLoading, isFetching } = usePaquetes(page, limit, search);

  const paqueteColumns = useMemo(
    () => getPaqueteColumns(["paquetes", page, limit, search]),
    [page, limit, search],
  );

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-6 w-80" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }

  const createPaqueteModal = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          + Registrar Paquete
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl xl:max-w-3xl">
        <DialogHeader>
          <DialogTitle>Registrar Paquete</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Llena el siguiente formulario para registrar un nuevo paquete.
        </DialogDescription>
        <div className="py-4">
          <RegisterPaqueteForm setOpen={setOpen} />
        </div>
      </DialogContent>
    </Dialog>
  );

  return (
    <section className="w-full p-3 sm:p-4 md:p-6 space-y-4 sm:space-y-6">
      <div>
        <DataTable<Paquete>
          columns={paqueteColumns}
          data={data?.data ?? []}
          total={data?.total ?? 0}
          page={page}
          limit={limit}
          onPageChange={setPage}
          isLoading={isFetching}
          search={search}
          onSearchChange={(value) => {
            setPage(1);
            setSearch(value);
          }}
          headerActions={createPaqueteModal}
        />
      </div>
    </section>
  );
}
